<template>
  <section class="faq content" id="faq" data-light-menu="false">
    <h2 v-if="content.title" class="faq__title" v-reveal>
      {{ content.title }}
    </h2>
    <h3 v-if="content.description" class="faq__description" v-reveal>
      {{ content.description }}
    </h3>

    <div>
      <FaqCard v-for="(item, index) in content.cards" :key="index" :content="item" />
    </div>
  </section>
</template>

<script>
import FaqCard from '@/components/cards/FaqCard.vue'
export default {
  name: 'FaqSection',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  components: {
    FaqCard,
  },
}
</script>
